var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5471 3.37205C13.738 3.12978 12.8839 3 12 3V1C13.081 1 14.1282 1.15889 15.1208 1.45608C18.9335 2.59764 21.9031 5.76337 22.9661 9.74187L21.0339 10.2581C20.1393 6.90994 17.6556 4.30275 14.5471 3.37205ZM10.5455 7.09091L6.45455 3L1 8.45455L15.5455 23L21 17.5455L16.9091 13.4545L15.5455 14.8182L9.18182 8.45455L10.5455 7.09091ZM7.71703 7.09091L6.45455 5.82843L3.82843 8.45455L15.5455 20.1716L18.1716 17.5455L16.9091 16.283L15.5455 17.6466L6.35339 8.45455L7.71703 7.09091ZM12 7C12.4867 7 12.9568 7.07438 13.4026 7.21344C15.115 7.74749 16.5212 9.25964 17.0314 11.2485L18.9686 10.7515C18.3042 8.16118 16.4385 6.06525 13.9981 5.30414C13.3629 5.10604 12.6922 5 12 5V7Z",
    fill: "#220C4A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.7279f93f91d87839099f6705510a5101.svg";
export { ForwardRef as ReactComponent };